"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboardConfigSchema = exports.newDashboardSchema = exports.oldDashboardSchema = void 0;
const zod_1 = require("zod");
exports.oldDashboardSchema = zod_1.z.object({
    questionId: zod_1.z.number().optional(),
    name: zod_1.z.string(),
});
exports.newDashboardSchema = zod_1.z.object({
    name: zod_1.z.string(),
    id: zod_1.z.number().optional(),
    type: zod_1.z.enum(['dashboard', 'question']),
    locked_params: zod_1.z.array(zod_1.z.object({
        param_type: zod_1.z.enum(['id', 'single_date', 'date_range']),
        param_name: zod_1.z.string(),
        param_value: zod_1.z.string(),
    })),
    filterable_params: zod_1.z.array(zod_1.z.object({
        param_type: zod_1.z.enum(['id', 'single_date', 'date_range']),
        param_name: zod_1.z.string(),
        param_value: zod_1.z.string(),
    })),
    hidden_filters: zod_1.z.array(zod_1.z.string()).optional(),
});
exports.dashboardConfigSchema = zod_1.z.array(zod_1.z.union([exports.oldDashboardSchema, exports.newDashboardSchema]));
